import makeFetch from "../../utils/http";

export function api_getAppointmentByID(id: number) {
    return makeFetch(
        `appointments/${id}`,
        "GET",
    );
}

export function api_patchAppointment(id, body) {
    return makeFetch(
        `appointments/${id}`,
        "PATCH",
        {},
        JSON.stringify(body)
    );
}

export function api_cancelOnBehalfOfUser(id, behalfOfUserId, body) {
    return makeFetch(
        `appointments/${id}/behalfOfUser/cancel `,
        "PATCH",
        {behalfOfUserId},
        JSON.stringify(body),
        true,
        "same-origin",
        true
    );
}


export function api_putOwnerReview(body) {
    return makeFetch(
        "reviews/ownerReviews",
        "PUT",
        {},
        JSON.stringify(body)
    );
}

export function api_putProviderReview(body) {
    return makeFetch(
        "reviews/providerReviews",
        "PUT",
        {},
        JSON.stringify(body)
    );
}

export function api_getAppointmentNotes(params) {
    return makeFetch(
        "appointmentnotes",
        "GET",
        params
    );
}

export function api_getAppointmentNoteByID(id) {
    return makeFetch(
        `appointmentnotes/${id}`,
        "GET",
    );
}

export function api_getFollowUpByID(appointmentId) {
    return makeFetch(
        "followUps",
        "GET",
        {appointmentId}
    );
}

export function api_patchFollowUp(body, id) {
    return makeFetch(
        `followUps/${id}`,
        "PATCH",
        {},
        JSON.stringify(body)
    );
}

export function api_postFollowUp(body) {
    return makeFetch(
        "followUps",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_setAppointmentNotes(body) {
    return makeFetch(
        "appointmentnotes",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_patchAppointmentNotes(id, body) {
    return makeFetch(
        `appointmentnotes/${id}`,
        "PATCH",
        {},
        JSON.stringify(body)
    );
}

export function api_addNewPrescription(body) {
    return makeFetch(
        "prescriptions",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_getPrescriptions(id) {
    return makeFetch(
        `prescriptions/appointment/${id}`,
        "GET",
    );
}

export function api_patchPrescriptionByID(id, body) {
    return makeFetch(
        `prescriptions/${id}`,
        "PATCH",
        {},
        JSON.stringify(body)
    );
}

export function api_deletePrescriptionByID(id) {
    return makeFetch(
        `prescriptions/${id}`,
        "DELETE",
    );
}

export function api_getHandouts() {
    return makeFetch(
        "handouts",
        "GET",
        {
            offset: 1,
            limit: 100,
        }
    );
}

export function api_getHandout(id) {
    return makeFetch(
        `handouts/${id}`,
        "GET",
    );
}
